<template>
  <div class="profile-page">
    <van-nav-bar
      title="个人中心"
      fixed
    />

    <div class="content">
      <div class="user-card" :class="{ 'clickable': !isLogged }" @click="!isLogged && goToLogin()">
        <div class="avatar">
          <van-icon name="user-o" size="40" />
        </div>
        <div class="user-info">
          <div v-if="isLogged" class="user-logged">
            <div class="username">{{ userInfo.userName || '-' }}</div>
            <div class="vip-status" :class="{ 'is-expired': isExpired }">
              <van-tag :type="isVip && !isExpired ? 'success' : 'default'" size="small">
                {{ isVip && !isExpired ? 'VIP 会员' : '普通会员' }}
              </van-tag>
              <span class="expire-time">
                {{ isVip && !isExpired ? '到期时间：' : '到期时间：' }}
                {{ formatDate(expireTime) }}
              </span>
            </div>
          </div>
          <div v-else class="user-not-logged">
            <div class="username">暂未登录</div>
            <div class="login-tip">点击登录 享受更多会员特惠</div>
          </div>
        </div>
      </div>

      <div class="action-list" v-if="isLogged">
        <div v-if="!isVip" class="action-item">
          <van-button type="primary" block round @click="handleRecharge">
            立即充值
          </van-button>
        </div>
        
        <div v-else-if="isExpired" class="action-item">
          <van-button type="warning" block round @click="handleRenew">
            续费会员
          </van-button>
        </div>

        <div class="action-item">
          <van-button type="default" block round @click="handleLogout">
            退出登录
          </van-button>
        </div>
      </div>

      <div class="action-list" v-else>
        <div class="action-item">
          <van-button type="primary" block round @click="goToLogin">
            立即登录
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '../utils/api';

export default {
  name: 'Profile',
  data() {
    return {
      userInfo: {
        id: null,
        userName: '',
        isVip: 'false',
        creatVipTime: ''
      }
    };
  },
  computed: {
    isLogged() {
      return !!this.userInfo.id;
    },
    isVip() {
      return this.userInfo.isVip === 'true';
    },
    isExpired() {
      if (!this.userInfo.creatVipTime) return true;
      const vipTime = typeof this.userInfo.creatVipTime === 'string' 
        ? parseInt(this.userInfo.creatVipTime) * 1000 
        : this.userInfo.creatVipTime * 1000;
      if (!vipTime) return true;
      const now = Date.now();
      return now > vipTime;
    },
    expireTime() {
      return this.userInfo.creatVipTime || 0;
    }
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      const userinfo = localStorage.getItem('userinfo');
      if (!userinfo) {
        return;
      }
      
      try {
        const parsed = JSON.parse(userinfo);
        if (!parsed || !parsed.data || !parsed.data.id) {
          return;
        }
        
        const userId = parsed.data.id;
        const res = await getUserInfo(userId);
        
        if (res && res.code === 200 && res.data) {
          this.userInfo = res.data;
        }
      } catch (error) {
        console.error('Fetch user info error:', error);
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '未开通';
      const ts = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
      if (!ts) return '未开通';
      const ts13 = ts * 1000;
      const date = new Date(ts13);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    goToLogin() {
      this.$router.push('/login');
    },
    handleRecharge() {
      this.$router.push('/recharge');
    },
    handleRenew() {
      this.$router.push('/recharge');
    },
    handleLogout() {
      this.$dialog.confirm({
        title: '确认退出',
        message: '确定要退出登录吗？'
      }).then(() => {
        localStorage.removeItem('userinfo');
        this.$router.push('/login');
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.profile-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
}

.content {
  padding: 16px;
}

.user-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.user-card.clickable {
  cursor: pointer;
}

.user-card.clickable:active {
  opacity: 0.7;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.user-info {
  flex: 1;
}

.user-logged,
.user-not-logged {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.username {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.user-not-logged .username {
  color: #666;
}

.login-tip {
  font-size: 13px;
  color: #1989fa;
}

.vip-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
}

.vip-status.is-expired {
  color: #ee0a24;
}

.expire-time {
  color: #999;
}

.vip-status.is-expired .expire-time {
  color: #ee0a24;
}

.action-list {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.action-item {
  margin-bottom: 12px;
}

.action-item:last-child {
  margin-bottom: 0;
}
</style>
